import { Box } from '@zillow/constellation-10';

type Props = {
  children: JSX.Element;
};

export default function FullPageNoConversationsWrapper({ children }: Props): JSX.Element {
  return (
    <Box css={{ height: '100%' }}>
      <Box
        css={{
          backgroundColor: 'bg.neutral',
          height: '100%',
          border: '1px solid',
          borderColor: 'border.muted',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
